<div class="mb-2 message-text">{{ data.message }}</div>
<div class="mt-2 d-flex justify-content-end">
  <button type="button" mat-raised-button color="primary" class="me-3" (click)="ok()">
    {{ data.primaryButtonLabel }}
  </button>
  <button mat-raised-button (click)="cancel()">
    {{ data.secondaryButtonLabel }}
  </button>
</div>
